export default __webpack_public_path__ + "static/media/List-documentation.ffc39d5b.md";